// @core/api/endpoints/notifications/get_team_member_overrides.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamMemberOverridesResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get team member notification overrides
 * Retrieves a team member's personal notification overrides that differ from the team's default settings.
 */
export async function GetTeamMemberOverrides(
  team_id: string,
  user_id: string,
  options?: RequestOptions
): Promise<GetTeamMemberOverridesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/teams/:team_id/members/:user_id/overrides`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.get<GetTeamMemberOverridesResponse>(requestPath, { ...requestOptions });
}
